// import logo from "./logo.svg";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Main from "./Main";
import Instructions from "./components/instructions/Instructions";

function App() {
  return (
    <div>
      <Router>
        <Routes>
          <Route path="/" exact element={<Main />} />
          <Route path="/instructions" exact element={<Instructions />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
